import { render, staticRenderFns } from "./categoryDcaProblem.vue?vue&type=template&id=19189840&scoped=true&"
import script from "./categoryDcaProblem.vue?vue&type=script&lang=js&"
export * from "./categoryDcaProblem.vue?vue&type=script&lang=js&"
import style0 from "./categoryDcaProblem.vue?vue&type=style&index=0&id=19189840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19189840",
  null
  
)

export default component.exports